export const getPXLBillingCreateRoute = () => '/billings/create';
export const getPXLBillingsRoute = () => '/billings';
export const getPXLBillingRoute = (billingId = null) => '/billings/' + (billingId ?? ':billingId');
export const getPXLOrdersRoute = () => '/my-orders';
export const getPXLOrderRoute = (orderId = null) => '/my-orders/' + (orderId ?? ':orderId');
